import axios from "axios";
import router from "../router";
import store from "../store";
import launchDarklyService from "../services/launchdarkly";
import configService from "../services/config";
import * as Sentry from "@sentry/vue";

/**
 * Create Axios Instance for API Call
 *
 * @param {boolean} withToken
 * @param { { headers: Object, baseURL: string } } options
 */
export const createAxiosInstance = (withToken = true, options = {}) => {
  // const { headers = {}, baseURL = `${process.env.VUE_APP_BASE_URL}` } = options;
  const { headers = {}, baseURL } = options;

  const instanceConfig = {
    baseURL: baseURL,
    headers: {
      "Content-Type": "application/json",
      ...(withToken
        ? { Authorization: "Token " + localStorage.getItem("token") }
        : {}),
      ...headers,
    },
  };

  const axiosInstance = axios.create(instanceConfig);
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      const response = error && error.response ? error.response : null;
      const status = response ? response.status : undefined;
      const data = response ? response.data : undefined;
      if (status === 401) {
        Sentry.setUser(null);
        configService.clearSecureConfig();
        localStorage.clear();
        launchDarklyService.resetToAnonymous();

        if (router.currentRoute.path != "/login") {
          router.push({
            path: "/login",
          });
        }
      }
      // Handle 404 Not Found errors (e.g., redirect to a custom 404 page)
      if (
        status === 404 &&
        data &&
        Object.prototype.hasOwnProperty.call(data, "detail") &&
        data.detail === "Not found."
      ) {
        store.dispatch("routeErrorHandling/setError", {
          code: 404,
          message: "Bad request. Please check your input.",
        });
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default createAxiosInstance;
